import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  actionsloading: false,
});

export function keyLearningAreaReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_KEY_LEARNING_AREAS:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.FETCH_KEY_LEARNING_AREA_SUCCESS:
    case actionTypes.FETCH_KEY_LEARNING_AREAS_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false,
      };
    default:
      return state;
  }
}
